/* Publish by EComposer at 2026-09-28 14:26:15*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0c0fsh58ct6u"]=  window.__ectimmers["ecom-0c0fsh58ct6u"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-0c0fsh58ct6u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0c0fsh58ct6u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7vapvvg876p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7vapvvg876p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-675znutwlbq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-675znutwlbq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ga0onm08n7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ga0onm08n7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7v1s1k95eco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7v1s1k95eco', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x4vc0eo0ks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x4vc0eo0ks', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rwjqjplo4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rwjqjplo4t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rty72aq8fyq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rty72aq8fyq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0u3ahbglhdcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0u3ahbglhdcm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5eikfo3dgu7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5eikfo3dgu7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-amijalph9yj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-amijalph9yj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gj5wv8fb2d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gj5wv8fb2d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5dj67vc54i7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5dj67vc54i7', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hmr557644xl"]=  window.__ectimmers["ecom-hmr557644xl"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-hmr557644xl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmr557644xl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b7iql3r1zar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b7iql3r1zar', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cj1rbuo6n9v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cj1rbuo6n9v', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-50t5xi02twb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-50t5xi02twb', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ktv7q3fhl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ktv7q3fhl', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vjjgd0dcikc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vjjgd0dcikc', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gv344hsrth7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gv344hsrth7', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}